export enum MediaFolders {
  ENTITY_IMAGES = 1,
  REPORTS = 2,
  PROFILE_IMAGES = 3,
  INVOICES = 4,
  PAYROLLS = 5,
}
